import { render } from "./View.vue?vue&type=template&id=b4448b78&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"

import "./View.vue?vue&type=style&index=0&id=b4448b78&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b4448b78"

export default script